import apiService from './apiService';
import apiServiceNew from './apiService.new';
import jwUploaderService from './jwUploaderService';

export default (function() {
	var mediaVersionPath = '/mediaVersion';
	var parseOptions = {
		'floats': ['Duration'],
		'datetimes': ['CreateDate', 'ModifyDate', 'DeleteDate', 'ExpireDate']
	};

	function get(id, version) {
		var url = mediaVersionPath + '/' + id + '/' + version;

		return apiService.getParsed(url, parseOptions);
	}

	function fetch(id) {
		var url = mediaVersionPath + apiService.paramsToQuery({
			mediaId: id
		});

		return apiService.getParsedArray(url, parseOptions);
	}

	function latest(mediaId) {
		var url = mediaVersionPath + '/latest' + apiService.paramsToQuery({
			mediaId: mediaId
		});

		return apiService.getParsed(url, parseOptions);
	}

	function latestPublic(mediaId, token) {
		var url = mediaVersionPath + '/latestPublic'
			+ apiService.paramsToQuery({
				mediaId: mediaId, token: token
			});

		return apiService.getParsed(url, parseOptions);
	}

	function create(body) {
		return apiServiceNew.post(mediaVersionPath, body).then(({data}) => {
			apiService.parse(data, parseOptions);
			return data;
		});
	}

	function update(data, params) {
		if (params === undefined) {
			params = {};
		}
		if (params.nullOverwrite === undefined) {
			params.nullOverwrite = true;
		}
		const url = mediaVersionPath + apiService.paramsToQuery(params);

		return apiService.put(JSON.stringify(data), url);
	}

	function remove(id, version) {
		var url = mediaVersionPath + '/' + id + '/' + version;

		return apiService.delete(null, url);
	}

	function createVideo({ID, Name, Description}, config) {
		const body = {
			MediaID: ID,
			Description,
			Name
		};
		const url = `${mediaVersionPath}/createVideo`;

		return apiServiceNew.post(url, body, config)
			.then(({data}) => data.status === 'ok' ? data.target : null);
	}

	function uploadVideo(url, file, config) {
		return jwUploaderService.saveVideo(url, file, config);
	}

	const updateHtmlLandingPage = (info) => apiServiceNew.put(`${mediaVersionPath}/updateHtmlLandingPage`, info);

	return {
		get: get,
		fetch: fetch,
		latest: latest,
		latestPublic: latestPublic,
		create: create,
		update: update,
		remove: remove,
		createVideo: createVideo,
		uploadVideo: uploadVideo,
		updateHtmlLandingPage: updateHtmlLandingPage
	};
})();